import {
	instance
} from '../../util/http'
import apis from '../../config/apis'
// 店长申请确认
const ManagerConfirmation = (data) => {
	return instance.post(apis.OwnerApply.ManagerConfirmation, data)
}
// // 查询确认人为用户店长审批记录   （店长申请查询分页）
const PartnerApprovalsList = (SaleStatus,Page, PageSize) => {
	return instance.get(apis.OwnerApply.GetSalePartnerApprovals + "?SaleStatus=" + SaleStatus +  "&Index=" + Page + "&Size=" + PageSize)
}

 

export default {
	ManagerConfirmation,
	PartnerApprovalsList
}